import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { ChunkWrapper, useLlm } from '@websolutespa/bom-mixer-llm';
import { AnimatePresence } from 'framer-motion';
import React from 'react';
import style from './stream.module.scss';

export type StreamProps = {
  index: number;
  className?: string;
};

export const Stream: React.FC<StreamProps> = ({ index, className }) => {
  const label = useLabel();
  const chunks = useLlm(state => state.chunks);
  const {
    BusyIndicator,
  } = useLlm(state => state.components);
  return (
    <>
      {chunks && (
        <section className={style.thread}>
          <div
            className={getClassNames(
              style.threadMessage,
              style.threadMessageAssistant
            )}
            role="region"
            aria-label={label('llm.answer')}
          >
            <AnimatePresence>
              {chunks.map((chunk, c) => (
                <ChunkWrapper
                  key={`llm-message-${index}-chunk-${c}`}
                  className={getClassNames(style.threadInner, style[chunk.type as string])}
                  item={chunk} chunkIndex={c} index={index} total={index + 1} role="assistant"
                  stream
                />
              ))}
              <BusyIndicator />
            </AnimatePresence>
          </div>
        </section>
      )}
    </>
  );
};
